module.exports = __webpack_public_path__ + "img/logo2-inverse.69a641da.svg";